import React, { useContext, useState } from 'react';
import { MaskedLink, VerticalListing, SecondaryIconButton } from '@hz-design-system/web-ui';
import { formatImageUrl, ImageSize } from '@ecg-marktplaats/media-util-js-lib';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import EnvironmentContext from '../../../contexts/EnvironmentContext';
import createFavorite from '../../Carousels/repositories/createFavorite';
import deleteFavorite from '../../Carousels/repositories/deleteFavorite';

import formatPrice from '../../FeedsApp/components/Feeds/utils/formatPrice';

import Classes from './SearchFeed.module.scss';

type TSearchFeedItemProps = {
  listing: any;
  toggleFavorite: any;
};

const SearchFeedItem = ({ listing, toggleFavorite }: TSearchFeedItemProps) => {
  const { t } = useI18nContext();
  const { isInApp, userLoggedIn, xsrfToken } = useContext(EnvironmentContext);
  const [isFavorite, setIsFavorite] = useState<boolean>(listing.isFavorited);

  const LinkComponent = MaskedLink; // TODO
  // const LinkComponent = searchListings.listings[0].thinContent ? MaskedLink : Link; // TODO
  const withFavoriting = !isInApp || userLoggedIn;

  const onFavorite = async (event, item) => {
    event.preventDefault();

    if (userLoggedIn) {
      setIsFavorite(!isFavorite);
      if (isFavorite) {
        await deleteFavorite(item.itemId, xsrfToken);
      } else {
        await createFavorite(item.itemId, xsrfToken);
      }
      toggleFavorite(item.itemId);
    } else {
      window.location.assign(`/account/login.html?target=${encodeURIComponent(window.location.href)}`);
    }
  };

  return (
    <LinkComponent
      kind="block"
      href={listing.url}
      className={Classes.listingCard}
      // onClick={() => onClick(item.correlationId)}
      // onContextMenu={() => {
      //   const newUrl = `${item.url}${item.url.includes('?') ? '&' : '?'}correlationId=${item.correlationId}`;
      //   setUrl(newUrl);
      // }}
      // {...(shouldOpenInNewTab && { target: '_blank' })}
    >
      <VerticalListing
        title={listing.title}
        price={listing.priceInfo ? formatPrice(listing.priceInfo, t, true, listing.isPricePerMonth) : ''}
        imageSrc={formatImageUrl(listing.picture?.url, ImageSize.Large, listing.picture?.sizes)}
        imageLoading="lazy"
        decoding="async"
      />
      {withFavoriting && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div onClick={(e) => onFavorite(e, listing)} className={Classes.favButton}>
          <SecondaryIconButton name={isFavorite ? 'heart-filled' : 'heart'} />
        </div>
      )}
    </LinkComponent>
  );
};

export default SearchFeedItem;
